import { cacheDom } from '../utils/QuerySelectors.js'
import { searchOrder, formatOrder } from '../utils/Customer.js'

const dom = {}
const qs = {
  section: 'data-section-type="customer-services"',
  heading: 'data-service-head',
  back: 'data-service-back',
  image: 'data-service-image',
  subNav: 'data-service-sub',
  subNavText: 'data-service-sub-text',
  navMobileSelected: 'data-service-mobile-selected',
  navMobileSelectedTitle: 'data-service-mobile-selected-title',
  internationalCopy: 'data-service-international-copy',
  returnNumber: 'data-annoymous-return-number',
  returnEmail: 'data-annoymous-return-email',
  returnSubmit: 'data-annoymous-return-submit',
  returnWrap: 'data-annoymous-return-wrap',
  returnPanel: 'data-annoymous-return-panel',
  returnError: 'data-annoymous-return-error',
}
const qsAll = {
  details: 'data-service-details',
  detailTriggers: 'data-service-details-btn',
  serviceLinks: 'data-service-item',
}
const state = {
  layoutType: '1',
  numberInputTimer: null,
  order: null,
}
const updateStatus = (toggle = true) => {
  dom.heading.classList.toggle('!hidden', toggle)
  dom.image.classList.toggle('!hidden', toggle)
  dom.back.classList.toggle('!hidden', !toggle)
  if (state.layoutType == '1') dom.subNav.classList.toggle('!hidden', !toggle)
}
export const setupCustomerServices = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    state.layoutType = dom.section.getAttribute('data-layout-type')
    const historyPath = '/account#order_history'
    dom.detailTriggers.forEach((detailTrigger) => {
      detailTrigger.addEventListener('click', () => {
        const detail = detailTrigger.closest(`[${qsAll.details}]`)
        dom.subNavText.innerHTML = detailTrigger.querySelector('h2').innerHTML
        if (state.layoutType == '1') {
          detailTrigger.disabled = true
          window.scrollTo(0, 0)
        }
        dom.details.forEach((d) => {
          if (d != detail) {
            d.removeAttribute('open')
            if (state.layoutType == '1') {
              d.classList.add('!hidden')
              d.querySelector(`[${qsAll.detailTriggers}]`).disabled = false
            }
          }
        })
        if (state.layoutType == '1') updateStatus()
      })
    })
    if (state.layoutType == '1') {
      dom.back.addEventListener('click', () => {
        dom.details.forEach((d) => {
          d.removeAttribute('open')
          d.classList.remove('!hidden')
          d.querySelector(`[${qsAll.detailTriggers}]`).disabled = false
        })
        updateStatus(false)
      })
    }
    dom.serviceLinks.forEach((serviceLink) => {
      serviceLink.addEventListener('click', (e) => {
        if (
          (serviceLink.closest('[data-service-url]').dataset.serviceUrl == historyPath ||
            serviceLink.closest('[data-service-url]').dataset.serviceUrl == '/account') &&
          !window.customerLogged
        ) {
          e.preventDefault()
          window.openAccountPopup()
        }
      })
    })

    // Mobile Navigation
    let selected = null
    dom.serviceLinks.forEach((navItem) => {
      if (location.href.includes(navItem.href)) selected = navItem
    })
    if (dom.navMobileSelectedTitle) dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
    if (location.hash == '#order_history') {
      let selected = null
      dom.serviceLinks.forEach((navItem) => {
        navItem.classList.toggle('underline', navItem.href.includes(historyPath))
        navItem.classList.toggle('hover:underline', !navItem.href.includes(historyPath))
        if (navItem.href.includes(historyPath)) selected = navItem
      })
      dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
    }

    dom.serviceLinks.forEach((navItem) => {
      navItem.addEventListener('click', () => {
        dom.serviceLinks.forEach((item) => {
          item.classList.toggle('underline', item == navItem)
          item.classList.toggle('hover:underline', item != navItem)
        })
        dom.navMobileSelectedTitle.innerHTML = navItem.innerHTML.trim()
      })
    })

    if (dom.navMobileSelected) {
      dom.navMobileSelected.addEventListener('click', (e) => {
        e.stopPropagation()
        dom.navMobileSelected.classList.toggle('account-mobile-nav-selected')
      })
      window.addEventListener('click', () => {
        dom.navMobileSelected.classList.remove('account-mobile-nav-selected')
      })
    }

    // Return Submit
    if(dom.returnSubmit) {
      dom.returnSubmit.addEventListener('click', () => {
        const email = dom.returnEmail.value?.trim()
        Shopify.analytics.publish('gtm_begin_refund');
        // if(window.userCountrySelection != 'US' || (!(window.userLocation && window.userLocation.country && window.userLocation.country == 'US'))) {
        if(window.userCountrySelection != 'US') {
          window.open('https://returns.esw.com/international.thombrown/en-IE', '_blank')
        } else {
          if(dom.returnNumber.value?.length == 6) {
            dom.returnError.innerHTML = window.pageStrings.returns.errors.oldOrder
            dom.returnError.classList.remove('!hidden')
          } else if(!!dom.returnNumber.value?.trim() && !!dom.returnEmail.value?.trim()) {
            dom.returnSubmit.disabled = true
            dom.returnSubmit.classList.add('button--loading')
            searchOrder((data) => {
              if((data.order && data.order.email != email) || !data.order) {
                dom.returnError.innerHTML = window.pageStrings.returns.errors.invalid
                dom.returnError.classList.remove('!hidden')
              } else {
                if(data.order?.shippingAddress?.countryCodeV2 != 'US') {
                  dom.internationalCopy.classList.add('!block')
                  dom.internationalCopy.closest(`[${qsAll.details}]`).querySelector(`[data-service-text]`)?.classList.add('!hidden')
                  dom.returnWrap?.classList.add('!hidden')
                } else {
                  const hasReturnableItems = data.order.lineItems.edges.filter(edge => edge.node.currentQuantity > 0 && edge.node.refundableQuantity > 0 && edge.node.refundableQuantity > edge.node.unfulfilledQuantity)
                  const now = new Date()
                  const parsedDate = new Date(data.order.createdAt)
                  const oneDay = 24 * 60 * 60 * 1000.0
                  const diffDays = (now - parsedDate) / oneDay
                  if(diffDays > 30) {
                    dom.returnError.innerHTML = window.pageStrings.returns.errors.miscriteria
                    dom.returnError.classList.remove('!hidden')
                  } else if(hasReturnableItems.length > 0) {
                    dom.returnError.classList.add('!hidden')
                    window.initOrderReturn(null, dom.returnPanel, null, formatOrder(data.order))
                  } else {
                    dom.returnError.innerHTML = window.pageStrings.returns.errors.notReturnable
                    dom.returnError.classList.remove('!hidden')
                  }
                }
              }
              dom.returnSubmit.disabled = false
              dom.returnSubmit.classList.remove('button--loading')
            },
            {
              number: dom.returnNumber.value?.trim()
            })
          }
        }
      })

      dom.returnNumber.addEventListener('input', () => {
        dom.returnError.classList.add('!hidden')
        dom.returnSubmit.classList.toggle('button--primary', !!dom.returnNumber.value?.trim() && !!dom.returnEmail.value?.trim())
      })
      dom.returnNumber.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          dom.returnSubmit.dispatchEvent(new Event('click'))
        }
      })
      dom.returnEmail.addEventListener('input', () => {
        dom.returnError.classList.add('!hidden')
        dom.returnSubmit.classList.toggle('button--primary', !!dom.returnNumber.value?.trim() && !!dom.returnEmail.value?.trim())
      })
      dom.returnEmail.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          dom.returnSubmit.dispatchEvent(new Event('click'))
        }
      })
    }

    if(dom.internationalCopy) {
      fetch('//ipinfo.io/json')
      .then(r=>r.json())
      .then(res=> {
        console.log(res)
        window.userLocation = res
        // if(window.userCountrySelection != 'US' || (!(window.userLocation && window.userLocation.country && window.userLocation.country == 'US'))) {
        if(window.userCountrySelection != 'US') {
          dom.internationalCopy.classList.add('!block')
          dom.internationalCopy.closest(`[${qsAll.details}]`).querySelector(`[data-service-text]`)?.classList.add('!hidden')
          dom.returnWrap?.classList.add('!hidden')
        }
      })
    }
  }
}
